import { useState } from 'react';
import { GlobalLoading } from '../../atoms';
import { Layout, useUser } from '@pella/react-layout';
import { Constants, isDev } from '../../../data/appConfig';
import { routes } from '../../../router/routes';
import { DevTools, LanguageSelector } from '../../molecules';

const ANALYTICS_EMAIL_ALLOWLIST = new Set([
  'misraa1@pella.com',
  'wiltdt@pella.com',
  'jewatters@pella.com',
  'kawebb@pella.com',
  'heuerji@pella.com',
]);

/**
 * The default layout structured with a top navbar, breadcrumb navigation, and page title.
 * Also includes a global loading indicator when any react-query queries are fetching
 */
const MainLayout = () => {
  const [devToolsModalOpen, setDevTools] = useState(false);
  const [languageSelectorOpen, setLanguageSelector] = useState(false);
  const user = useUser();

  const toggleDevTools = () => setDevTools((prev) => !prev);
  const toggleLanguageSelector = () => setLanguageSelector((prev) => !prev);
  const languageOption = { text: 'Change Language', icon: 'language', onClick: toggleLanguageSelector };
  const devTools = { text: 'Dev Tools', icon: 'service_toolbox', onClick: toggleDevTools };
  const avatarOptions = [...(isDev ? [devTools] : []), languageOption];

  let roleValues = [];
  if (Array.isArray(user?.roles)) {
    roleValues = user.roles;
  } else if (typeof user?.roles === 'string') {
    roleValues = [user.roles];
  }

  const isAdmin = roleValues.some((role) => String(role).toUpperCase() === 'ADMINISTRATOR');
  const userEmail = String(user?.email || '').toLowerCase();
  const hasAnalyticsAccess = isAdmin || ANALYTICS_EMAIL_ALLOWLIST.has(userEmail);

  const routesForUser = routes.filter((route) => (route.path === 'analytics' ? hasAnalyticsAccess : true));

  return (
    <>
      <Layout
        hideBreadcrumbs={false}
        appName={Constants.AppName}
        routes={routesForUser}
        avatarOptions={avatarOptions}
      />
      <DevTools isOpen={devToolsModalOpen} onClose={toggleDevTools} />
      <LanguageSelector isOpen={languageSelectorOpen} onClose={toggleLanguageSelector} />
      <GlobalLoading />
    </>
  );
};

export default MainLayout;
